<template>
  <div id="page_history" class="column p0 minH100">
    <!-- ......................................... -->
    <div class="cointainer_xl column combo_1">
      <!-- {{rowsOnPage[3]}} -->
      <!-- ....... -->
      <div class="columns column">
        <div class="column page_landing_welcome_title is-three-fifths">
          <h1 class="component_title_lg fat m0_b">
            <div class="icon_class_1" v-html="iconSets.general_history"></div>
            {{ $tc("msg.transaction", 2) }}
          </h1>
        </div>
        <!-- .. -->
      </div>
      <!-- ....... -->
      <div class="componenet_card_tabs">
        <!-- <a
          class="componenet_card_tab"
          v-bind:class="{
            componenet_card_tab_selected: tableSelected == 'probability',
          }"
          @click="showTable('probability')"
          >{{ $t("msg.probability") }}</a
        > -->
        <a
          class="componenet_card_tab"
          v-bind:class="{
            componenet_card_tab_selected: tableSelected == 'internal_transfer',
          }"
          @click="showTable('internal_transfer')"
          >{{ $t("msg.internal_transfer") }}</a
        >
        <a
          class="componenet_card_tab"
          v-bind:class="{
            componenet_card_tab_selected: tableSelected == 'withdraw',
          }"
          @click="showTable('withdraw')"
          >{{ $t("msg.withdraws") }}</a
        >
        <a
          class="componenet_card_tab"
          v-bind:class="{
            componenet_card_tab_selected: tableSelected == 'purchase',
          }"
          @click="showTable('purchase')"
          >{{ $t("msg.purchase") }}</a
        >
        <a
          class="componenet_card_tab"
          v-bind:class="{
            componenet_card_tab_selected: tableSelected == 'redemption',
          }"
          @click="showTable('redemption')"
          >{{ $t("msg.redemption") }}</a
        >
        <a
          class="componenet_card_tab"
          v-bind:class="{
            componenet_card_tab_selected: tableSelected == 'deposits',
          }"
          @click="showTable('deposits')"
          >{{ $t("msg.deposits") }}</a
        >
      </div>
      <div class="component_card">
        <div class="column">
          <h1 class="component_title_md fat m0_b">
            {{ $t(`msg.${tableSelected}`) }}
          </h1>
        </div>
        <div class="column">
          <!-- <transaction-table-probability
            v-if="tableSelected == 'probability'"
          ></transaction-table-probability> -->
          <transaction-table-internal
            v-if="tableSelected == 'internal_transfer'"
          ></transaction-table-internal>
          <transaction-table-redeem
            v-if="tableSelected == 'redemption'"
          ></transaction-table-redeem>
          <transaction-table-purchase
            v-if="tableSelected == 'purchase'"
          ></transaction-table-purchase>
          <transaction-table-referral
            v-if="tableSelected == 'referral'"
          ></transaction-table-referral>
          <transaction-table-deposits
            v-if="tableSelected == 'deposits'"
          ></transaction-table-deposits>
          <transaction-table-withdraw
            v-if="tableSelected == 'withdraw'"
          ></transaction-table-withdraw>
        </div>
      </div>
    </div>
    <!-- ......................................... -->
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import VueCsvDownloader from "vue-csv-downloader";
import spacetime from "spacetime";

import TransactionTableProbability from "../../components/private/transactions/TransactionTableProbability";
import TransactionTablePurchase from "../../components/private/transactions/TransactionTablePurchase";
import TransactionTableRedeem from "../../components/private/transactions/TransactionTableRedeem";
import TransactionTableReferral from "../../components/private/transactions/TransactionTableReferral";
import TransactionTableDeposits from "../../components/private/transactions/TransactionTableDeposits";

import TransactionTableWithdraw from "../../components/Transactions/TransactionTableWithdraw";
import TransactionTableInternal from "../../components/Transactions/TransactionTableInternal";

export default {
  created() {
    this.checkParams();
  },
  mounted() {},
  data: () => ({
    tableSelected: "",
  }),
  components: {
    Datepicker,
    VueCsvDownloader,
    TransactionTableRedeem,
    TransactionTableReferral,
    TransactionTablePurchase,
    TransactionTableDeposits,
    TransactionTableWithdraw,
    TransactionTableInternal,
    TransactionTableProbability
  },
  methods: {
    showTable(type) {
      this.tableSelected = type;
    },

    checkParams() {
      this.tableSelected = this.$route.params.arg;
    },
  },
  computed: {},
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/views/private/Transactions.vue